var pathnamePrefixes = ['/jira/', '/wiki/', '/browse/'];
var ATLAS_HOST = 'home.atlassian.com';
var ATLAS_TEAM_HOST = 'team.atlassian.com';
export var normaliseUrl = function normaliseUrl(url) {
  try {
    var parsedUrl = new URL(url);
    var normalizedPath = '/any/';
    if (parsedUrl.host === ATLAS_HOST || parsedUrl.host === ATLAS_TEAM_HOST) {
      // Replace org ID with "orgId" in the path
      normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
    }
    var prefixRegex = new RegExp("^(".concat(pathnamePrefixes.join('|'), ")"));
    if (prefixRegex.test(parsedUrl.pathname)) {
      normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
    }
    var normalizedUrl = "".concat(parsedUrl.protocol, "//").concat(parsedUrl.host).concat(normalizedPath);
    return normalizedUrl;
  } catch (error) {
    return 'https://could-not-parse.example.com';
  }
};